import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Icon } from '@iconify/react';
import { Box } from '@mui/material';
import { isImageIcon } from '../../utils/iconHelpers';

const Iconify = forwardRef(({ color, icon, width = 20, clickable = true, sx, ...other }, ref) =>
  isImageIcon(icon) ? (
    <Box
      ref={ref}
      component="img"
      src={icon}
      sx={{
        width,
        height: width,
        objectFit: 'cover',
        borderRadius: 0.5,
        ...sx,
        '&:hover': {
          cursor: clickable ? 'pointer' : 'inherit',
        },
      }}
      {...other}
    />
  ) : (
    <Box
      ref={ref}
      component={Icon}
      icon={icon || 'ic:baseline-error'}
      sx={{
        width,
        height: width,
        color: color ? (theme) => theme.palette[color].main : 'inherit',
        ...sx,
        '&:hover': {
          cursor: clickable ? 'pointer' : 'inherit', // Optional: enhances UX by changing the cursor on hover
        },
      }}
      {...other}
    />
  )
);

Iconify.propTypes = {
  sx: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  color: PropTypes.oneOf(['default', 'primary', 'secondary', 'info', 'success', 'warning', 'error', 'white']),
};

export default Iconify;
